import { LandscapeTypes, SET_LANDSKAPE } from "../types/landscape";

export const setLandscape = (isLandscape: Boolean): LandscapeTypes => 
  ({
    type: SET_LANDSKAPE,
    payload: isLandscape
  })